export default __webpack_public_path__ + "static/media/footer1New.ff93729d.png";